import script from "./searchInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./searchInvoice.vue?vue&type=style&index=0&id=aaa047fe&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa047fe"]])

export default __exports__